module.exports = __webpack_public_path__ + "static/project1lap-ba93583ff51c8b724c7098a64af3e8f9.png";